var React = require('react');

function Add (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM8.43751 4.5C8.67914 4.5 8.87501 4.69587 8.87501 4.9375V7.22222H11.0625C11.3041 7.22222 11.5 7.4181 11.5 7.65972V8.53472C11.5 8.77635 11.3041 8.97222 11.0625 8.97222H8.87501V11.0625C8.87501 11.3041 8.67914 11.5 8.43751 11.5H7.56251C7.32089 11.5 7.12501 11.3041 7.12501 11.0625V8.97222H4.93751C4.69589 8.97222 4.50001 8.77635 4.50001 8.53472V7.65972C4.50001 7.4181 4.69589 7.22222 4.93751 7.22222H7.12501V4.9375C7.12501 4.69587 7.32089 4.5 7.56251 4.5H8.43751Z","fill":"#6366F1"}));
}

Add.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Add;

Add.default = Add;
